import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import Poweredby_after from "./Powered-by/Poweredby_after";
import completed_editions from "../../Assets/img/completed_edition.png";
import { make_request } from "../Utils/Utils";


class Completed_editions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      finalists: []
    };
  }

  async componentDidMount() {
    let responseJson = await make_request({
      path: `hall_of_fame?id=${this.props.editionId}`,
      method: 'GET'
    });
    if(responseJson){
      if(responseJson.status === "success"){
        this.setState({
          name: responseJson.name,
          year: responseJson.year,
          finalists: responseJson.finalists || [],
          description: responseJson.description
        });
      }
    }
  }
 

  render() {
    const { finalists} = this.state;
    return (
      <div className="innerBody">
        <Header />

         <div className="completed_editions container">

            <div className="row mt-5 mb-5 topsec">

              <div className="col-lg-5 col-md-12 col-12 mt-3">

                <h3 className="mb-3"> SUMMER EDITION'2.0 </h3>

                <h5 className="mb-3"> Time Spent: 2 Days, 18 Hours, 23 Minutes </h5>

                <p className="mb-3"> <span> Your Rank &nbsp; &nbsp; <b> 158 </b> out of 1564868 </span> </p>

                <p className="mb-3"> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est </p>

                <button type="button" className="btn btn-yellow "> PLAY  </button> &nbsp; &nbsp;
                <button type="button" className="btn btn-yellow "> HALL OF FAME  </button>             
            
              </div>

              <div className="col-lg-7 col-md-12 col-12 text-right">
                <img src={completed_editions} alt="" />
              </div>

            </div>   


            <div className="HallOfFrame">
            <div className="row mt-4 mb-5 section-table">
                <div className="col">
                  
                  <div className="table-responsive card body-card border-0 mt-3 p-2">
                    <table className="table mt-3 mb-0">
                      <thead className="thead-yellow">
                        <tr>
                          <th scope="col" className="rank">RANK</th>
                          <th scope="col" className="name">Name</th>
                          <th scope="col" className="username">Display name</th>
                          <th scope="col" className="country">Country</th>
                        </tr>
                      </thead>
                      <tbody >
                        {
                          finalists.map((user, inx) => {
                            return(
                              <tr key={inx+1} style={{background: "#141414"}}>
                                <td className="rank">{inx+1}</td>
                                <td className="name">{user.name}</td>
                                <td className="username">{user.display_name}</td>
                                <td className="country">{user.country}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            </div>



         </div>

        <div className="bg_dark"> <Poweredby_after /> </div>

        <Footer />
      </div>
    );
  }
}

export default Completed_editions;
